export default {
    severity_1: 'Moderate',
    severity_2: 'Severe',
    severity_3: 'Any',
};
